import PropTypes from "prop-types";
import { childrenPropType, classNamePropType, requiredPropType } from "../../common";

/**
 * PropTypes for Label component
 *
 * @property {React.ReactNode} [children] - Label text content
 * @property {string} [className] - Additional CSS classes
 * @property {string} [htmlFor] - Associated input element ID
 * @property {boolean} [required] - Show required indicator (asterisk)
 */
export const labelPropTypes = {
  children: childrenPropType,
  className: classNamePropType,
  htmlFor: PropTypes.string,
  required: requiredPropType,
};
